/**
 * Web Push requires an active service worker. Production registers via
 * `setupProductionServiceWorkerLifecycle()` in ClientLayout; development does not —
 * this helper registers on demand before push subscribe/getSubscription.
 */
import { ensureServiceWorkerRegistered } from "@/lib/pwa/service-worker-client";

export async function ensurePushServiceWorkerRegistered(): Promise<ServiceWorkerRegistration> {
  return ensureServiceWorkerRegistered();
}
